import { useState, useEffect } from 'react';

export function useProgressiveImage(lowQualitySrc, highQualitySrc) {
  const [src, setSrc] = useState(lowQualitySrc);

  useEffect(() => {
    const img = new Image();
    img.src = highQualitySrc;
    img.onload = () => {
      setSrc(highQualitySrc);
    };
  }, [highQualitySrc]);

  return src;
}